'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSellerEndedCatalogsIfNeeded = exports.isEndedCatalogsLoading = exports.getLoadTimeForEndedCatalogs = exports.getEndedCatalogs = exports.LOAD_SELLER_ENDED_CATALOGS_SUCCESS = exports.LOAD_SELLER_ENDED_CATALOGS_REQUEST = exports.LOAD_SELLER_ENDED_CATALOGS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('../modules/user');

var _config = require('../modules/config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_SELLER_ENDED_CATALOGS_FAIL = exports.LOAD_SELLER_ENDED_CATALOGS_FAIL = 'la/domain/sellerEndedCatalogs/LOAD_FAIL';
var LOAD_SELLER_ENDED_CATALOGS_REQUEST = exports.LOAD_SELLER_ENDED_CATALOGS_REQUEST = 'la/domain/sellerEndedCatalogs/LOAD_REQUEST';
var LOAD_SELLER_ENDED_CATALOGS_SUCCESS = exports.LOAD_SELLER_ENDED_CATALOGS_SUCCESS = 'la/domain/sellerEndedCatalogs/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_SELLER_ENDED_CATALOGS_FAIL:
            return (0, _extends5.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.sellerId])
            });
        case LOAD_SELLER_ENDED_CATALOGS_REQUEST:
            return (0, _extends5.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_SELLER_ENDED_CATALOGS_SUCCESS:
            var _action$meta = action.meta,
                actionTime = _action$meta.actionTime,
                sellerId = _action$meta.sellerId;

            var newState = (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, sellerId, action.payload.catalogs.map(function (catalog) {
                    return catalog.catalogId;
                }))),
                loading: (0, _difference2.default)(state.loading, [sellerId])
            });
            // TODO: make this reducer pure
            // dont set loaded if we're on the server because we'll need to get the rest
            newState.loaded = global.__SERVER__ ? (0, _extends5.default)({}, state.loaded) : (0, _extends5.default)({}, state.loaded, (0, _defineProperty3.default)({}, sellerId, actionTime));
            return newState;
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.sellerEndedCatalogs;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns the data
var getEndedCatalogs = exports.getEndedCatalogs = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

// takes in a (state, id) and returns the load time
var getLoadTimeForEndedCatalogs = exports.getLoadTimeForEndedCatalogs = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns the is loading
var isEndedCatalogsLoading = exports.isEndedCatalogsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchEndedCatalogs = function shouldFetchEndedCatalogs(state, sellerId) {
    if (!sellerId) return false;
    var item = getEndedCatalogs(state, sellerId);
    if (item.length) {
        var loaded = getLoadTimeForEndedCatalogs(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isEndedCatalogsLoading(state, sellerId);
    return !loading;
};

/* ACTION CREATORS */
var loadEndedCatalogs = function loadEndedCatalogs(sellerId, page, count, sortTerm) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: sellerId,
                                type: LOAD_SELLER_ENDED_CATALOGS_REQUEST
                            });
                            _context.next = 7;
                            return _api.SellerCatalogs.fetchSellerEndedCatalogsById({
                                authToken: authToken,
                                count: count,
                                deployment: deployment,
                                page: page,
                                sellerId: sellerId,
                                sortTerm: sortTerm
                            });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), sellerId: sellerId },
                                payload: response.data,
                                type: LOAD_SELLER_ENDED_CATALOGS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { sellerId: sellerId },
                                payload: _context.t0,
                                type: LOAD_SELLER_ENDED_CATALOGS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchSellerEndedCatalogsIfNeeded = exports.fetchSellerEndedCatalogsIfNeeded = function fetchSellerEndedCatalogsIfNeeded(sellerId, page, count, sortTerm) {
    return function (dispatch, getState) {
        if (shouldFetchEndedCatalogs(getState(), sellerId)) {
            return dispatch(loadEndedCatalogs(sellerId, page, count, sortTerm));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/sellerEndedCatalogs.js
// module id = wFxa
// module chunks = 46